import { render, staticRenderFns } from "./PFRow.vue?vue&type=template&id=24091733&"
import script from "./PFRow.vue?vue&type=script&lang=js&"
export * from "./PFRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports